import { render } from "./NoDuplicates.vue?vue&type=template&id=061b7cd8"
import script from "./NoDuplicates.vue?vue&type=script&lang=js"
export * from "./NoDuplicates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__